import clsx from 'clsx';
import { DecreasedArrowIcon, IncreasedArrowIcon } from '../../assets/icons';
import { formatPercentages } from '../../helpers';
import moment from 'moment';
import ProgressBar from '../../components/ProgressBar';

type DailyBarChartProps = {
    className?: string;
    title: string;
    dailyDifference?: string;
    dayOfWeekTotal?: {
        value: number;
        label: string;
    }[];
    isLoading: boolean;
};

const defaultData = [...Array(7)].map((_, index) => ({
    value: 0,
    label: moment.weekdaysShort(index + 1),
}));

const DailyBarChart: React.FC<DailyBarChartProps> = ({
    className,
    title,
    dailyDifference,
    dayOfWeekTotal,
    isLoading,
}) => {
    const highestValue = dayOfWeekTotal
        ? dayOfWeekTotal.reduce(
              (highest, cur) => (cur.value > highest ? cur.value : highest),
              0
          )
        : 0;

    return (
        <div className={clsx('chart', className)}>
            <div className='title'>
                <span>{title}</span>
                <div className='percentage'>
                    {isLoading ? (
                        '-'
                    ) : (
                        <>
                            {' '}
                            {dailyDifference && +dailyDifference < 0 ? (
                                <DecreasedArrowIcon />
                            ) : (
                                <IncreasedArrowIcon />
                            )}
                            {formatPercentages(dailyDifference || 0, 0)}%
                        </>
                    )}
                </div>
            </div>
            <div className='value'>
                {isLoading
                    ? '-'
                    : dayOfWeekTotal?.[moment().isoWeekday() - 1]?.value || '0'}
            </div>
            <div className='bar-chart'>
                {(dayOfWeekTotal || defaultData).map((data, index) => (
                    <div
                        className={clsx('bar', {
                            active: index === moment().isoWeekday() - 1,
                        })}
                        key={index}
                    >
                        <span className='bar-chart-value'>
                            {isLoading ? '-' : data.value}
                        </span>
                        <div className='bar-chart-progress'>
                            <ProgressBar
                                type='vertical'
                                value={data.value}
                                total={highestValue}
                            />
                        </div>
                        <div className='bar-chart-label'>{data.label}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};
export default DailyBarChart;
